import Joi from 'joi';

export const schema = Joi.object({
  paymentMethod: Joi.string()
    .min(4)
    .error(new Error('Medio pago es requerido')),
  bank: Joi.string().error(new Error('Banco es requerido')),
  comment: Joi.string()
    .min(5)
    .max(200)
    .error(new Error('Máximo 200 caracteres.')),
});
